import { useEffect, useRef, useState } from "react";
import "./TopSection.scss";
import { getCategories } from "../../../services/products";
import { useCookies } from "react-cookie";
import { useTranslation } from "react-i18next";
import "swiper/swiper-bundle.css";
import { useSearchParams } from "react-router-dom";

export default function TopSection() {
  const [cookie] = useCookies(["access_token"]);
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const [categories, setCategories] = useState([]);
  const [endItem, setEndItem] = useState(
    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) ? 2 : 4,
  );
  const deviceType = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
    ? "mobile"
    : "desktop";

  useEffect(() => {
    cookie?.access_token &&
      getCategories(cookie?.access_token).then(
        (res) => res && setCategories(res),
      );
  }, []);

  useEffect(() => {
    if (categories?.length > 0 && categories?.length < endItem) {
      setEndItem(categories?.length);
    }
  }, [categories]);

  const [, setIsFixed] = useState(false);
  const isFixedRef = useRef(false); // Ref to track the state without causing re-renders

  useEffect(() => {
    const handleScroll = () => {
      const targetDiv = document.getElementById("menu-categories");
      if (!targetDiv) return;

      const rect = targetDiv.getBoundingClientRect();

      if (deviceType === "desktop") {
        if (rect.top <= 95 && !isFixedRef.current) {
          setIsFixed(true);
          isFixedRef.current = true;
        } else if (window.scrollY <= 550 && isFixedRef.current) {
          setIsFixed(false);
          isFixedRef.current = false;
        }
      } else {
        if (rect.top <= 0 && !isFixedRef.current) {
          setIsFixed(true);
          isFixedRef.current = true;
        } else if (window.scrollY <= 450 && isFixedRef.current) {
          setIsFixed(false);
          isFixedRef.current = false;
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="search-top-section">
      <div className="title-description">
        <div className="title">
          <p>{"Търсене"}</p>
        </div>
        <div className="description">
          <p>{`Резултати от търсенето на "${searchParams.get("search")}"`}</p>
        </div>
      </div>
    </div>
  );
}
